/**
 *
jQuery.CaracolWordpressJson
version 1.0
Hiroshi Fukuda <dada@sygnas.jp>
http://sygnas.jp/

WordPress用 Jsonp吐き出しプラグイン「Export File Json」の吐き出すJsonを読み込んで表示する
*/

/*
{%ID%}      記事ID
{%NUM%}     記事番号 0～
{%TYPE%}    post / カスタムタイプ
{%POSTDAY%} 投稿日
{%POSTDAY_Y%}   投稿日 年
{%POSTDAY_M%}   投稿日 月
{%POSTDAY_D%}   投稿日 日
{%POSTTIME%}    投稿日 年
{%POSTTIME_H%}  投稿時刻 時
{%POSTTIME_M%}  投稿時刻 分
{%POSTTIME_S%}  投稿時刻 秒
{%TITLE%}   題名
{%LINK%}    記事URL
{%THUMB_SRC%}   サムネイル URL
{%THUMB_WIDTH%} サムネイル 幅
{%THUMB_HEIGHT%}    サムネイル　高さ
{%CATEGORY_NAME%}   記事カテゴリ
{%CATEGORY_SLUG%}   記事カテゴリスラッグ
{%CATEGORY_NAME_ALL%}   記事カテゴリ　全部
{%CATEGORY_SLUG_ALL%}   記事カテゴリスラッグ　全部
{%TERM_SLUG%}   タクソノミースラッグ
{%TERM_SLUG_ALL%}   タクソノミースラッグ　全部
{%CONTENT%} 本文
{%CUSTOM_任意文字%} カスタムフィールド


2017.07.24 ver1.1
- オプション include / exclude でカテゴリーの指定ができるようにした
2017.03.20 ver1.0
- ES2015対応、JSON対応で作り直し

-------------
usage
-------------
var CaracolWordpressJson = require('./caracol/wordpress/jquery.wpjsonp.js');
wpjsonp = new CaracolWordpressJson({
    format: '<dt>{%POSTDAY%}</dt><dd><a href="{%LINK%}">{%TITLE%}</a></dd>',
    onComplete: function(data){
        $('.js-news').html(data);
    }
});
wpjsonp.load('http://shingeki.tv/news/output/export_new_jsonp.php');
*/


export default class CaracolWordpressJson {

    /**
     * コンストラクタ
     * @param {object} config
     */
    constructor(config) {
        const defaults = {
            format: '<li><a href="{%LINK%}">{%TITLE%}</a></li>',
            include: [],
            exclude: [],
            onComplete() { }
        };
        this.opt = $.extend(defaults, config);
        this.outputArray = [];
    }

    /**
     * 読み込み
     * @param {string} url json url
     */
    load(url) {
        // 読み込み開始
        $.ajax(url, {
            dataType: 'json',
            context: this
        })
        .done(this._load_complete);
    }

    /**
     * 読み込み完了
     * @param {*} data
     * @param {*} textStatus
     * @param {*} jqXHR
     */
    _load_complete(data, textStatus, jqXHR) {

        for (let i = 0; i < data.length; i += 1) {

            // 各アーティクル情報
            const article = data[i];

            // 表示対象じゃなければ次へ
            if (!this._is_include(article)) {
                continue;
            }
            // 除外対象じゃなければ次へ
            if (this._is_exclude(article)) {
                continue;
            }

            let format = this.opt.format;

            format = format.split('{%ID%}').join(article.id);
            format = format.split('{%NUM%}').join(i);
            format = format.split('{%TYPE%}').join(article.type);

            format = format.split('{%POSTDAY%}').join(article.postday);
            format = format.split('{%POSTDAY_Y%}')
                .join(article.postday.substr(0, 4));
            format = format.split('{%POSTDAY_M%}')
                .join(article.postday.match(/\d+\.(\d+)\.\d+/)[1]);
            format = format.split('{%POSTDAY_D%}')
                .join(article.postday.match(/\d+\.\d+\.(\d+)/)[1]);

            format = format.split('{%POSTTIME%}').join(article.posttime);
            format = format.split('{%POSTTIME_H%}')
                .join(article.posttime.match(/(\d+):\d+:\d+/)[1]);
            format = format.split('{%POSTTIME_M%}')
                .join(article.posttime.match(/\d+:(\d+):\d+/)[1]);
            format = format.split('{%POSTTIME_S%}')
                .join(article.posttime.match(/\d+:\d+:(\d+)/)[1]);

            format = format.split('{%TITLE%}').join(article.title);
            format = format.split('{%LINK%}').join(article.link);

            if (article.thumbnail) {
                format = format.split('{%THUMB_SRC%}')
                    .join(article.thumbnail.src);
                format = format.split('{%THUMB_WIDTH%}')
                    .join(article.thumbnail.width);
                format = format.split('{%THUMB_HEIGHT%}')
                    .join(article.thumbnail.height);
            }

            format = format.split('{%CATEGORY_NAME%}')
                .join(article.category_name[0]);
            format = format.split('{%CATEGORY_SLUG%}')
                .join(article.category_slug[0]);
            format = format.split('{%CATEGORY_NAME_ALL%}')
                .join(article.category_name.join(' '));
            format = format.split('{%CATEGORY_SLUG_ALL%}')
                .join(article.category_slug.join(' '));

            format = format.split('{%TERM_SLUG%}')
                .join(article.terms_slug[0]);
            format = format.split('{%TERM_SLUG_ALL%}')
                .join(article.terms_slug.join(' '));

            format = format.split('{%CONTENT%}').join(article.content);

            const matches = format.match(/{%CUSTOM_.+?%}/);

            if (matches) {
                for (let p = 0; p < matches.length; p += 1) {
                    const key = matches[p].match(/{%CUSTOM_(.+?)%}/)[1];
                    format = format.split(matches[p]).join(article.custom[key]);
                }
            }

            // 出力テキスト
            this.outputArray.push(format);
        }

        // 指定された完了関数を実行
        this.opt.onComplete(this.outputArray);
    }

    /**
     * 指定されたカテゴリーだったら true を返す。それ以外は false
     * @param {Object} article
     */
    _is_include(article) {

        // include オプションが無指定だったら表示対象ということで true を返す
        if (this.opt.include.length <= 0) {
            return true;
        }

        const include = this.opt.include;
        const categories = article.category_slug;

        for (let i = 0; i < include.length; i += 1) {
            if ($.inArray(include[i], categories) >= 0) {
                return true;
            }
        }

        return false;
    }

    /**
     * 除外指定されたカテゴリーだったら true を返す。それ以外は false
     * @param {Object} article
     */
    _is_exclude(article) {

        // exclude オプションが無指定だったら除外対象ではないということで false を返す
        if (this.opt.exclude.length <= 0) {
            return false;
        }

        const exclude = this.opt.exclude;
        const categories = article.category_slug;

        for (let i = 0; i < exclude.length; i += 1) {
            if ($.inArray(exclude[i], categories) >= 0) {
                return true;
            }
        }

        return false;
    }
}






// WEBPACK FOOTER //
// /Users/dada/www/_caracol_works/javascript/for_webpack/caracol/caracol_es2015.1.0/wordpress/wpjson.js